import { TaskCommentsList } from './TaskCommentsList';
import { TaskNewCommentForm } from './TaskNewCommentForm';

interface TaskCommentsTabContentProps {
  taskId: string;
  isAdding: boolean;
  onNavigateToCommentsList: () => void;
}

export const TaskCommentsTabContent = ({
  taskId,
  isAdding,
  onNavigateToCommentsList,
}: TaskCommentsTabContentProps) =>
  isAdding ? (
    <TaskNewCommentForm taskId={taskId} onGoBack={onNavigateToCommentsList} />
  ) : (
    <TaskCommentsList taskId={taskId} />
  );
